export const Site = {
    ref: 'nmsCreatureBuilder',
    kurt: {
        fullName: 'Kurt Lourens',
        nickName: 'Khaoz-Topsy',
        website: 'https://kurtlourens.com',
        twitter: 'https://twitter.com/KhaozTopsy',
        github: 'https://github.com/Khaoz-Topsy',
    },
    nms: {
        home: 'https://nomanssky.com',
        galacticAtlas: 'https://galacticatlas.nomanssky.com',
    },
    assistantNMS: {
        fullName: 'Assistant for No Man\'s Sky',
        nickName: 'AssistantNMS',
        website: 'https://nmsassistant.com',
        api: 'https://api.nmsassistant.com',
        twitter: 'https://twitter.com/AssistantNMS',
        github: 'https://github.com/AssistantNMS',
    },
    nmscd: {
        fullName: 'No Man\'s Sky Community Developers',
        nickName: 'NMSCD',
        website: 'https://nmscd.github.io/',
        github: 'https://github.com/NMSCD',
        projectsPage: 'https://nmscd.github.io/projects.html',
    },
    assistantApps: {
        name: 'AssistantApps',
        email: 'mailto:support@assistantapps.com',
        website: 'https://assistantapps.com',
        tools: 'https://tools.assistantapps.com',
        github: 'https://assistantapps.com/github',
        discord: 'https://assistantapps.com/discord',
        patreon: 'https://www.patreon.com/AssistantApps',
    }
}